import {
  TextField,
  Typography,
  Button,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useState } from "react";
import PasswordImage from "assets/password.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAuth } from "hooks/useAuth";
import { useHistory } from "react-router-dom";
import { useConsigazApi } from "hooks/useConsigazApi";

export default function StepPassword({
  segment,
  cpfCnpj,
  onForgot,
  cpfAccess,
}) {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const { login } = useAuth();

  const router = useHistory();

  const api = useConsigazApi();

  const handleLogin = async () => {
    const cleanCpfcnpj = cpfCnpj.replace(/[^0-9A-Za-z]/g, "").toUpperCase();
    try {
      const success = await login({
        password,
        cpfCnpj: segment === "CONTASIM" ? cleanCpfcnpj : cpfAccess,
        type: segment,
      });
      if (success) {
        const { Cliente } = await api.consultaLocalEntrega(cleanCpfcnpj);

        router.push({
          pathname: "/existent-client",
          state: { cliente: Cliente.ClienteRetorno[0] },
        });
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  return (
    <>
      <img src={PasswordImage} />
      <Typography
        color="#FFFFFF"
        fontWeight={700}
        fontSize={"30px"}
        mt={"30px"}
      >
        Informe sua senha
      </Typography>
      <Typography color="#FFFFFF" fontSize={"15px"} mt={"10px"}>
        Insira sua senha para acessar o portal Consigaz com os registros de seus
        endereços.
      </Typography>

      <TextField
        variant="standard"
        color="secondary"
        value={password}
        fullWidth
        onChange={(e) => {
          setPassword(e.target.value);
        }}
        placeholder={"Senha"}
        type={showPassword ? "text" : "password"}
        sx={{
          mt: 8,
          "& input": {
            paddingLeft: "34px",
          },
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                  size="small"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />

      <Button
        variant="contained"
        color="secondary"
        sx={{
          height: "45px",
          color: "#fff",
          borderRadius: "36px",
          width: "100%",
          mt: 2,
        }}
        onClick={handleLogin}
      >
        Avançar
      </Button>

      <Typography
        color="#2CABF9"
        fontWeight={600}
        fontSize={"15px"}
        mt={2}
        mb={8}
        sx={{
          cursor: "pointer",
        }}
        onClick={onForgot}
      >
        Esqueci minha senha
      </Typography>
    </>
  );
}
